import Vue from 'vue'
import './styles/quasar.scss'
import lang from 'quasar/lang/pt-br.js'
import '@quasar/extras/roboto-font/roboto-font.css'
import Quasar, { Notify, Dialog } from 'quasar'
import iconSet from 'quasar/icon-set/mdi-v5.js'
import '@quasar/extras/mdi-v5/mdi-v5.css'

Vue.use(Quasar, {
  iconSet,
  plugins: { Notify, Dialog },
  lang: lang
})
